/** Ids of the iframes content-shell and pages-shell render activity content into */
export const SHELL_FRAME_IDS: readonly string[] = ['contentShellFrame', 'TutorialContentShellFrame', 'pagesShellFrame'];

const SHELL_ROUTE_PATHS: readonly string[] = ['/content-shell', '/pages-shell'];

/**
 * Engines, Pages and LTI tools redirect their own frame to an LMS URL on exit, session expiry or error.
 * Booting the LMS UI inside the shell iframe renders a second header, replaces the shell content and
 * lets the nested app clear the shared sessionStorage, so hand the URL to the shell's window instead.
 * Shell-route redirects show a recovery message rather than relaunching the same content in a loop.
 * Returns true when the app must not bootstrap in this window.
 */
export function escapeShellFrame(win: Window = window): boolean {
  let frame: Element | null;
  try {
    // Null when top-level or framed cross-origin (e.g. LTI inside an external LMS), so those are untouched.
    frame = win.frameElement;
  } catch {
    return false;
  }

  if (!frame || !SHELL_FRAME_IDS.includes(frame.id)) {
    return false;
  }

  const path = win.location.pathname.replace(/\/+$/, '').toLowerCase();
  const isShellRoute = SHELL_ROUTE_PATHS.some(shellPath => path.endsWith(shellPath));
  console.warn(`LMS UI loaded inside #${frame.id} (${win.location.pathname}); not bootstrapping nested app.`);

  // Re-opening a shell route would relaunch the same content, which could redirect here again in a loop.
  if (isShellRoute) {
    const recovery = win.document.createElement('main');
    recovery.setAttribute('role', 'alert');
    const heading = win.document.createElement('h1');
    heading.textContent = 'Activity could not be restored';
    const message = win.document.createElement('p');
    message.textContent = 'Close this activity and launch it again.';
    recovery.append(heading, message);
    win.document.body.replaceChildren(recovery);
  } else {
    win.parent.location.replace(win.location.href);
  }
  return true;
}
